import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appFileInputReset]',
  standalone: false
})
export class FileInputResetDirective {
  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Allow picking the same file again
    setTimeout(() => (input.value = ''));
  }
}
